var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0665 9.15556H15.111V17.8667H5.15539V6.66667H2.6665V25.3333H5.15539V21.6H27.5554V25.3333H30.0443V14.1333C30.0443 12.8131 29.5198 11.547 28.5863 10.6135C27.6528 9.68 26.3867 9.15556 25.0665 9.15556ZM10.1332 16.6222C11.1233 16.6222 12.0729 16.2289 12.773 15.5288C13.4732 14.8286 13.8665 13.879 13.8665 12.8889C13.8665 11.8987 13.4732 10.9492 12.773 10.249C12.0729 9.54889 11.1233 9.15556 10.1332 9.15556C9.14303 9.15556 8.19344 9.54889 7.49331 10.249C6.79317 10.9492 6.39984 11.8987 6.39984 12.8889C6.39984 13.879 6.79317 14.8286 7.49331 15.5288C8.19344 16.2289 9.14303 16.6222 10.1332 16.6222Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.16211bca56523f8565d4d54c5cac3507.svg";
export { ForwardRef as ReactComponent };